import { createFileRoute } from '@tanstack/react-router'
import { StaffLifeEvents } from '../../../../components/StaffLifeEvents'

export const Route = createFileRoute('/platform/desa/$desaId/life-events')({
  component: () => {
    const { desaId } = Route.useParams()
    return <StaffLifeEvents desaId={desaId} />
  },
})
